// extracted by mini-css-extract-plugin
module.exports = {"root":"IconSocialMediaYoutube_root__q95gX"};